import { IdAssetBundleCalloutIcons } from "../../assetBundles/IdAssetBundleCalloutIcons";
import { BF2CreateAsset } from "../BF2BuildingGraphicsUtils";
var Container = PIXI.Container;
export var GetDiscountCallouts = function () {
    var container = new Container();
    var config = [
        {
            colliders: [
                {
                    offset: [-40, -80],
                    size: [80, 120],
                    type: 0,
                },
            ],
            id: IdAssetBundleCalloutIcons.CallOutWhite,
        },
        {
            id: IdAssetBundleCalloutIcons.PrimeSaleIcn,
            offset: [0, -17],
        },
    ];
    var assets = config.map(function (cfg) { return BF2CreateAsset(cfg); });
    if (assets) {
        container.addChild.apply(container, assets);
    }
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/GetDiscountCallouts.ts
// module id = 2151
// module chunks = 3